import { observable, action, makeObservable } from 'mobx';
import { GliveStore, CHANNEL_TYPE, ROLE_TYPE } from '@gaodun.com/g2-live-sdk';
import { Modal, message } from 'antd';
import { ReportType } from '@gaodun.com/g2-live-sdk/lib/app/implements/report';
import { appendUrlParams } from '@/utils/openExtraUrl';
const hash = window.location.hash.slice(0, window.location.hash.indexOf('?'));
const isRecord = hash.includes('record');
declare let window: Window & {
    ipc?: any;
    appPath: string;
    macVersion?: string;
    curVersion?: string;
};
if (window.ipc) {
    // 获取appPath
    window.ipc.send('get-app-path');
    window.ipc.on('got-app-path', (e: any, path: string) => {
        console.log(path, 'path');
        window.appPath = path;
    });
    window.ipc.on('macVersion', (e: any, macVersion: string) => {
        console.log('macVersion', macVersion);
        window.macVersion = macVersion;
    });
    window.ipc.on('current-version', (e: any, version: string) => {
        console.log('curVersion', version);
        window.curVersion = version;
    });
}
interface ILivePosition {
    x: number;
    y: number;
}

interface IBounds {
    left: number;
    top: number;
    right: number;
    bottom: number;
}

export class LiveRoomStore extends GliveStore {
    private tokenFailureCodes = [553649434, 553649437, 553649438, 553649443, 77000000, 77000117, 10120002];
    @observable liveDuration = '00:00';
    // 数据看板/学员列表分组筛选展示：无筛选时为“全部”
    @observable selectedGroupId = '';
    @observable selectedGroupName = '全部';
    // 竖屏模式：小框位置
    @observable livePosition: ILivePosition = { x: 0, y: 0 };
    // 视频拖拽边界
    @observable liveBounds = { left: 0, top: 0, right: 0, bottom: 0 };
    // 白板拖拽边界
    @observable whiteBounds = { left: 0, top: 0, right: 0, bottom: 0 };
    // 快捷回复弹窗显隐
    @observable quickReplayVisible = false;
    // 消息审核弹窗显隐
    @observable messageCheckVisible = false;
    // 消息审核设置弹窗显隐
    @observable messageCheckSettingsVisible = false;
    // 助教选择器弹窗显隐
    @observable assistantSelectorVisible = false;
    // 营销活动选择器弹窗显隐
    @observable marketingVisible = false;
    // 营销活动选择回调
    @observable marketingHandler: ((item: any, type: string) => void) | null = null;
    // 私聊里面的展示群聊
    @observable showAssistantSelector = false;

    constructor() {
        super();
        makeObservable(this);
        // 监听 sdk error
        this.EventInstance.on(CHANNEL_TYPE.ERROR, msg => {
            if (msg.from === 'api' && msg.content?.includes('getOnlineUserCount')) {
                return;
            }
            if (msg.status && this.tokenFailureCodes.includes(msg.status) && this.roleType === ROLE_TYPE.STUDENT && !isRecord) {
                const loginUrl = this.roomConfig?.loginUrls?.webUrl;
                if (loginUrl) {
                    const redirectTarget = loginUrl.includes('next.gaodun.com')
                        ? `${window.location.href}&internal=true`
                        : window.location.href;
                    window.location.href = appendUrlParams(loginUrl, { redirect: redirectTarget });
                    return;
                }
            }
            message.destroy();
            message.error(msg.info);
            if (!!this.reportStore && !!this.reportStore.selfTestConfig) {
                this.reportStore.setErrorInfo({
                    errorCode: 7001,
                    errorMsg: JSON.stringify(msg),
                });
                this.reportStore.reportData(Date.now(), { scene: ReportType.ERROR_EVENT });
            }
        });

        // 监听 sdk warning
        this.EventInstance.on(CHANNEL_TYPE.WARNING, function (msg) {
            message.destroy();
            message.warning(msg.info);
        });

        // 监听 sdk info
        this.EventInstance.on(CHANNEL_TYPE.INFO, function (msg) {
            message.destroy();
            message.warning(msg.info);
        });
        // 监听 sdk info
        this.EventInstance.on(CHANNEL_TYPE.MODAL, function (msg) {
            message.destroy();
            Modal.info({
                title: '提示',
                className: 'tip-modal',
                content: msg.info,
                okText: '知道了',
            });
        });
        this.EventInstance.on(CHANNEL_TYPE.SUCCESS, msg => {
            message.destroy();
            message.success(msg.info);
        });
    }

    @action
    setLiveDuration(duration: string) {
        this.liveDuration = duration;
    }
    @action
    setLivePosition(livePosition: ILivePosition) {
        this.livePosition = livePosition;
    }
    @action
    setLiveBounds(bounds: IBounds) {
        this.liveBounds = bounds;
    }
    @action
    setWhiteBounds(bounds: IBounds) {
        this.whiteBounds = bounds;
    }
    @action
    setQuickReplayVisible(visible: boolean) {
        this.quickReplayVisible = visible;
    }
    @action
    setMessageCheckVisible(visible: boolean) {
        this.messageCheckVisible = visible;
    }
    @action
    setMessageCheckSettingsVisible(visible: boolean) {
        this.messageCheckSettingsVisible = visible;
    }

    @action
    setAssistantSelectorVisible(visible: boolean) {
        this.assistantSelectorVisible = visible;
    }

    @action
    setMarketingVisible(visible: boolean) {
        this.marketingVisible = visible;
    }

    @action
    setMarketingHandler(handler: ((item: any, type: string) => void) | null) {
        this.marketingHandler = handler;
    }

    @action
    setShowAssistantSelector(visible: boolean) {
        this.showAssistantSelector = visible;
    }

    @action
    setSelectedGroup(groupId: string, groupName: string) {
        this.selectedGroupId = groupId;
        this.selectedGroupName = groupName || '全部';
    }
}
